import Cookies from 'js-cookie'

/**
 * 存储数据
 */
export const setItem = (key, value, type = 'storage') => {
  // 将数组、对象类型的数据转化为 JSON 字符串进行存储
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }

  if (type === 'storage') {
    window.localStorage.setItem(key, value)
  } else {
    Cookies.set(key, value, {
      expires: 3,
      path: '/',
      domain: process.env.VUE_APP_SHARE_DOMAIN
    })
  }
  // window.localStorage.setItem(key, value)
}

/**
 * 获取数据
 */
export const getItem = (key, type = 'storage') => {
  // const data = window.localStorage.getItem(key)
  let data
  if (type === 'storage') {
    data = window.localStorage.getItem(key)
  } else {
    data = Cookies.get(key)
  }

  try {
    return JSON.parse(data)
  } catch (err) {
    return data
  }
}

/**
 * 删除数据
 */
export const removeItem = (key, type = 'storage') => {
  if (type === 'storage') {
    window.localStorage.removeItem(key)
  } else {
    Cookies.remove(key, {
      path: '/',
      domain: process.env.VUE_APP_SHARE_DOMAIN
    })
  }
}

/**
 * 删除所有数据
 */
export const removeAllItem = () => {
  window.localStorage.clear()
  Cookies.removeAll()
}
